import { Component, ViewChild, ElementRef } from '@angular/core';

import { AppLoginModalComponent } from '../app-login/app-login.component'

import { DbService } from '../../db.service';
import { SessionService } from '../../session.service';
import { SpinnerService } from '../../spinner.service';

import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';

declare var powerbi: any;

@Component({
    selector: 'app-pesquisa-salarial-demo',
    templateUrl: './pesquisa-salarial-demo.component.html',
    styleUrls: ['./pesquisa-salarial-demo.component.css']
})

export class PesquisaSalarialSHDemoComponent {
    @ViewChild("login") login: AppLoginModalComponent;
    @ViewChild('embeddedReport')
    
    embeddedReport: ElementRef;
    config: any;

    showBloqueio: boolean = false;

    constructor(
        private _scrollToService: ScrollToService,
        private dbService: DbService,
        private sessionService: SessionService,
        private spinnerService: SpinnerService
    ) {
        this.fnPesquisar();
    }

    fnPesquisar() {
        const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario')  || '{}');

        //this.dbService.post('EmbedInfo/VerificaPermissaoNCP', sessao.hash).subscribe(resultPersonalizado => {
            // if (!resultPersonalizado.permissao)
            // {
                
                        this.dbService.get('EmbedInfo/GetPesquisaSalarialSHDemo').subscribe(result => {
                            var pages = [];
                            const model = window['powerbi-client'].models;
                            this.config = result;
                            
                            const embedConfig = {
                                type: 'report',
                                tokenType: model.TokenType.Embed,
                                accessToken: result.embedToken.token,
                                embedUrl: result.embedReport[0].embedUrl,
                                permissions: model.Permissions.All,
                                settings: {
                                    filterPaneEnabled: false,
                                    navContentPaneEnabled: false,
                                    layoutType: model.LayoutType.Custom,
                                    customLayout: {
                                        displayOption: model.DisplayOption.FitToWidth
                                    }
                                }
                            }
                            var report = powerbi.embed(this.embeddedReport.nativeElement, embedConfig);
                            //report.fullscreen();
                        });
            
    }

    fullscreen() {
        // Get a reference to the embedded report HTML element
        var embedContainer = this.embeddedReport.nativeElement

        // Get a reference to the embedded report.
        var report = powerbi.get(embedContainer);

        // Displays the report in full screen mode.
        report.fullscreen();
    }

    fnScrollTo() {
        const config: ScrollToConfigOptions = {
            target: 'resultado',
            offset: -97
        };
      
        this._scrollToService.scrollTo(config);
    }

}
